module.exports = __webpack_public_path__ + "static/media/dropdown.ff68653b.svg";